<template>
	<div>
		<!-- 双列 -->
		<div v-if="multi">
			<div
				class="data-list"
				:style="[style]"
				v-for="(item, index) in multiseriate"
				v-bind:key="index"
			>
				<div v-for="val in item.one" :key="val.label" class="item-list" :style="[val.style]">
					<div v-if="val.label">{{ val.label }}</div>
					<div>{{ val.value }}</div>
				</div>
				<div v-for="(val, idx) in item.two" :key="idx" class="item-list" :style="[val.style]">
					<div v-if="val.label">{{ val.label }}</div>
					<div>{{ val.value }}</div>
				</div>
			</div>
		</div>
		<!-- 单列 -->
		<div v-else>
			<div
				class="data-list"
				:style="[style || item.style]"
				v-for="(item, index) in multiseriate"
				v-bind:key="index"
			>
				<div class="item" v-if="item.label">{{ item.label || item[props.label] }}</div>
				<div class="item">{{ item.value || item[props.value] }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import account from './index.js';
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {};
	},
	computed: {
		multiseriate() {
			let { scope, tableData } = this;
			if (!(scope && tableData)) return false;
			return tableData.multiseriate(scope.row[tableData.bind], scope.row);
		},
		style() {
			let { scope, tableData } = this;
			if (!(scope && tableData)) return false;
			return tableData.style;
		},
		multi() {
			let { scope, tableData } = this;
			if (!(scope && tableData)) return false;
			return tableData.multi;
		},
		props() {
			let { scope, tableData } = this;
			if (!(scope && tableData)) return false;
			return tableData.props;
		},
	},
	watch: {},
	mounted() {},
	methods: {},
	components: { ...account },
};
</script>
<style lang="scss" scoped>
.data-list {
  display: flex;
  align-items: center;
  color: #333;
}

.item-list {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.5em;
}

.item {
  flex: 1;
}
</style>
